import { render, staticRenderFns } from "./AddUpdatePackage.vue?vue&type=template&id=076e133f&"
import script from "./AddUpdatePackage.vue?vue&type=script&lang=js&"
export * from "./AddUpdatePackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports